module.exports = __webpack_public_path__ + "img/ZJ5230.6ac0a7e2.png";